<template>
  <chart-card
    title="Faturamento"
    display-mode
    :is-pdf-content="isPdfContent"
    :data="chartData"
    :chart-loading="loading"
    is-currency
    legends
    :use-chart-type.sync="useCardChartType"
  />
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import ChartCard from '@/components/ChartCard.vue'
import { mapState } from 'vuex'
import * as helpers from '@/config/helpers.js'
import { colors } from '@/config/colors.js'

export default {
  components: {
    ChartCard,
  },
  props: {
    groupBy: {
      type: String,
      default: 'monthly',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isPdfContent: {
      type: Boolean,
      default: false,
    },
    useChartType: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    faturamentoClube: [],
    faturamentoForaClube: [],
  }),
  computed: {
    ...mapState({
      comparativoCharts: (state) => state.clube.comparativoCharts,
    }),
    useCardChartType: {
      get() {
        return this.useChartType
      },
      set(value) {
        this.$emit('update:useChartType', value)
      },
    },
    chartData() {
      const arrayClube = cloneDeep(this.faturamentoClube)
      const arrayForaClube = cloneDeep(this.faturamentoForaClube)
      /* Sometimes the array do not have matching dates. These 2 foreach statements
      fills in missing dates for both arrays */
      arrayClube.forEach((element, index) => {
        if (!arrayForaClube.find((el) => JSON.stringify(el.data) === JSON.stringify(element.data))) {
          arrayForaClube.splice(index, 0, { ...element, valor: 0.0 })
        }
      })

      arrayForaClube.forEach((element, index) => {
        if (!arrayClube.find((el) => JSON.stringify(el.data) === JSON.stringify(element.data))) {
          arrayClube.splice(index, 0, { ...element, valor: 0.0 })
        }
      })

      return {
        labels: [...this.faturamentoClube.map((object) => object.data)],
        datasets: [
          {
            label: 'Faturamento do clube',
            backgroundColor: colors[1],
            strokeColor: colors[1],
            borderColor: colors[1],
            data: [...arrayClube.map((object) => object.valor)],
            fill: false,
          },
          {
            label: 'Faturamento fora do clube',
            backgroundColor: colors[0],
            strokeColor: colors[0],
            borderColor: colors[0],
            data: [...arrayForaClube.map((object) => object.valor)],
            fill: false,
          },
        ],
      }
    },
  },
  watch: {
    comparativoCharts() {
      this.formatData()
    },
  },
  mounted() {
    this.formatData()
    this.$nextTick(() => {
      this.$bus.$on('filter', this.formatData)
    })
  },
  destroyed() {
    this.$bus.$off('filter')
  },
  methods: {
    onSetCardChartType(value) {
      this.$emit('set-card-chart-type', value)
    },
    formatData() {
      if (this.groupBy === 'monthly') {
        this.faturamentoClube = helpers.agrupamentoMensal(this.comparativoCharts, 'VAL_FATURAMENTO_FIDELIDADE')
        this.faturamentoForaClube = helpers.agrupamentoMensal(this.comparativoCharts, 'VAL_FATURAMENTO_NAO_FIDELIDADE')
      }

      if (this.groupBy === 'weekly') {
        this.faturamentoClube = helpers.agrupamentoSemanal(this.comparativoCharts, 'VAL_FATURAMENTO_FIDELIDADE')
        this.faturamentoForaClube = helpers.agrupamentoSemanal(this.comparativoCharts, 'VAL_FATURAMENTO_NAO_FIDELIDADE')
      }

      if (this.groupBy === 'daily') {
        this.faturamentoClube = helpers.agrupamentoDiario(this.comparativoCharts, 'VAL_FATURAMENTO_FIDELIDADE')
        this.faturamentoForaClube = helpers.agrupamentoDiario(this.comparativoCharts, 'VAL_FATURAMENTO_NAO_FIDELIDADE')
      }
    },
  },
}
</script>
<style lang="scss">
.faturamento-loader {
  height: 320px;
}
</style>
